module.exports = __webpack_public_path__ + "static/img/office5.46c41f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/office/office5.png
// module id = U6a3
// module chunks = 1